import { defaultHttpClient } from '../../httpClient';
import type { GetAiStudioProductInfoResponse } from './types';

export const getAiStudioProductInfo = (marketSno: number) => {
  return defaultHttpClient
    .request<GetAiStudioProductInfoResponse>({
      method: 'GET',
      url: `/api/v2/markets/${marketSno}/ai-studio-product-info/`,
    })
    .then(result => result.data);
};
